<div style="overflow: hidden !important; " class="background">
    <div fxLayout="row" fxLayoutAlign="space-between center">
        <div fxLayout="column" fxFlex="5"></div>
        <div fxLayout="column" fxFlex="90"  fxLayoutAlign="center">
            <div fxLayout="row" fxLayoutAlign="space-between center" style="height: 100px;">
                <div fxLayout="column" fxFlex="10"></div>
                <div fxLayout="column" fxLayoutAlign="center center" class="circle" fxFlex="10">
                    <img style="height: auto;width: 70px"  loading="lazy" alt="AppiWorks Logo 3D" src="https://storage.googleapis.com/jivrus-web-images/jcp/box/hubspot/hubspot-logo.png"/>
                </div>
                <div fxLayout="column" fxFlex="10"></div>
                <div fxLayout="column" fxLayoutAlign="center center" class="circle" fxFlex="10">
                    <img style="height: auto;width: 70px"  loading="lazy" alt="AppiWorks Logo 3D" src="https://storage.googleapis.com/jivrus-web-images/jcp/box/mongodb/mongodb-logo.png"/>
                </div>
                <div fxLayout="column" fxFlex="10"></div>
                <div fxLayout="column" fxFlex="10"></div>
                <div fxLayout="column" fxLayoutAlign="center center" class="circle" fxFlex="10">
                    <img style="height: auto;width: 40px;"  loading="lazy" alt="AppiWorks Logo 3D" src="https://storage.googleapis.com/jivrus-web-images/jcp/box/google-sheets/google-sheets-logo.png"/>
                </div>
                <div fxLayout="column" fxFlex="10"></div>
                <div fxLayout="column" fxLayoutAlign="center center" class="circle" fxFlex="10">
                    <img style="height: auto;width: 60px;"  loading="lazy" alt="AppiWorks Logo 3D" src="https://storage.googleapis.com/jivrus-web-images/jcp/box/mysql/mysql_logo.png"/>
                </div>
                <div fxLayout="column" fxFlex="10"></div>
            </div>

            <div fxLayout="row" fxLayoutAlign="space-between center" style="height: 100px;">
                <div fxLayout="column" fxLayoutAlign="center center" class="circle"  class="circle"  fxFlex="10">
                    <img style="height: 55px;width: 55px"  loading="lazy" alt="AppiWorks Logo 3D" src="https://storage.googleapis.com/jivrus-web-images/jcp/box/postgresql/postgresql-logo.png"/>
                </div>
                <div fxLayout="column" fxFlex="10"></div>
                <div fxLayout="column" fxLayoutAlign="center center" class="circle" fxFlex="10">
                    <img style="height: 55px;width: 55px"  loading="lazy" alt="AppiWorks Logo 3D" src="https://storage.googleapis.com/jivrus-web-images/jcp/box/insightly/insightly-logo.png"/>
                </div>
                <div fxLayout="column" fxFlex="10"></div>
                <div fxLayout="column" fxLayoutAlign="center center" fxFlex="20">
                    <img style="height: 140px;width: auto" class="shake"  loading="lazy" alt="AppiWorks Logo 3D" src="https://storage.googleapis.com/jivrus-web-images/products/appiworks/appiworks-logo-3d.png"/>
                </div>
                <div fxLayout="column" fxFlex="10"></div>
                <div fxLayout="column" fxLayoutAlign="center center" class="circle" fxFlex="10">
                    <img style="height: 55px;width: 55px"  loading="lazy" alt="AppiWorks Logo 3D" src="https://storage.googleapis.com/jivrus-web-images/jcp/box/snowflake/snowflake-logo.png"/>
                </div>
                <div fxLayout="column" fxFlex="10"></div>
                <div fxLayout="column" fxLayoutAlign="center center" class="circle" fxFlex="10">
                    <img style="height: 55px;width: 55px"  loading="lazy" alt="AppiWorks Logo 3D" src="https://storage.googleapis.com/jivrus-web-images/jcp/box/capsule/capsule-logo.png"/>
                </div>
            </div>

            <div fxLayout="row" fxLayoutAlign="space-between center" style="height: 100px;">
                <div fxLayout="column" fxFlex="10"></div>
                <div fxLayout="column" fxLayoutAlign="center center" class="circle" fxFlex="10">
                    <img style="height: 55px;width: 55px"  loading="lazy" alt="AppiWorks Logo 3D" src="https://storage.googleapis.com/jivrus-web-images/jcp/box/aws-redshift/amazon-redshift-logo.png"/>
                </div>
                <div fxLayout="column" fxFlex="10"></div>
                <div fxLayout="column" fxLayoutAlign="center center" class="circle" fxFlex="10">
                    <img style="height: 55px;width: 55px"  loading="lazy" alt="AppiWorks Logo 3D" src="https://storage.googleapis.com/jivrus-web-images/jcp/box/aws-dynamodb/awsdynamodb-logo.png"/>
                </div>
                <div fxLayout="column" fxFlex="10"></div>
                <div fxLayout="column" fxFlex="10"></div>
                <div fxLayout="column" fxLayoutAlign="center center" class="circle" fxFlex="10">
                    <img style="height: 55px;width: 55px"  loading="lazy" alt="AppiWorks Logo 3D" src="https://storage.googleapis.com/jivrus-web-images/jcp/box/google-forms/google-forms-logo.png"/>
                </div>
                <div fxLayout="column" fxFlex="10"></div>
                <div fxLayout="column" fxLayoutAlign="center center" class="circle" fxFlex="10">
                    <img style="height: 55px;width: auto"  loading="lazy" alt="AppiWorks Logo 3D" src="https://storage.googleapis.com/jivrus-web-images/jcp/box/google-cloud-storage/google-cloud-storage-logo.png"/>
                </div>
                <div fxLayout="column" fxFlex="10"></div>
            </div>

            <!-- <div fxLayout="row" fxLayoutAlign="center center" style="height: 100px;">
                <button mat-button color="primary"  type="button">
                     <span> See all integrations </span>
                  </button>
            </div> -->

        </div>
        <div fxLayout="column" fxFlex="5"></div>
    </div>
</div>
